'use client';

import { Button, Container, Stack, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';

import { Link } from '@/i18n/navigation';
import colors from '@/styles/themes/colors';

import styles from './ErrorPage.module.scss';

const ErrorPage = () => {
  const t = useTranslations('common');

  return (
    <Container classes={{ root: styles.root }} className={styles.containerWrapper} maxWidth={false} disableGutters>
      <Container maxWidth="xl" disableGutters>
        <Stack className={styles.container} spacing={3}>
          <Typography component="h1" variant="h1" fontWeight={700} color={colors.white} textAlign="center">
            {t('errorTitle')}
          </Typography>
          <Typography variant="body1" color={colors.graytone50} textAlign="center">
            {t('errorDescription')}
          </Typography>
          <Link href="/" aria-label="Go Back Home" className={styles.link}>
            <Button variant="contained" size="large" className={styles.button}>
              {t('goBackHome')}
            </Button>
          </Link>
        </Stack>
      </Container>
    </Container>
  );
};

export default ErrorPage;
